type CareerOption = {
  id: string;
  label: string;
};

export const DEFAULT_CAREER_OPTIONS: CareerOption[] = [
  { id: 'data-analyst', label: 'Data Analyst' },
  { id: 'registered-nurse', label: 'Registered Nurse' },
  { id: 'software-developer', label: 'Software Developer' },
  { id: 'project-manager', label: 'Project Manager' },
];

export const DEFAULT_GOAL_OPTIONS: CareerOption[] = [
  { id: 'just-exploring', label: 'Just exploring' },
  { id: 'upskilling', label: 'Upskilling' },
  { id: 'career-change', label: 'Career change' },
  { id: 'getting-promoted', label: 'Getting promoted' },
];

export const DEFAULT_LEVEL_OPTIONS: CareerOption[] = [
  { id: 'beginner', label: 'Beginner' },
  { id: 'intermediate', label: 'Intermediate' },
  { id: 'advanced', label: 'Advanced' },
];
